module.exports = __webpack_public_path__ + "img/zkhy.096dbff4.png";